import React, { useEffect, useRef } from 'react'
import './styles.scss'
import Carousel from 'nuka-carousel'
import { renderRichText } from '../../utils'

export default function ImageCarouselBlock({
  subtitle,
  copyright,
  slides = [],
  currentSlide,
  isEditor = false,
}) {
  const ref = useRef()
  useEffect(() => {
    // console.log(ref.current)
  }, [ref.current])
  let atts = []
  if (!isEditor) atts['data-scroll'] = 'true'

  return (
    <div className={'dhsv-slider-block dhsv-image-carousel-block'} {...atts}>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 col-xl-10">
          <Carousel
            ref={ref}
            className={'slider'}
            slideIndex={currentSlide}
            dragging={!isEditor}
            withoutControls={isEditor}
            // heightMode={'current'}
          >
            {slides.map((slide, key) => (
              <SlideItem
                key={key}
                slideIndex={key}
                {...slide}
                isEditor={isEditor}
              />
            ))}
          </Carousel>
          {subtitle && (
            <div className={`image-subtitle-content`}>
              <p className={'image-subtitle-subtitle'}>{subtitle}</p>
              {copyright && (
                <p className={'image-subtitle-copyright'}>{copyright}</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export const SlideItem = ({ ...slide }, isEditor) => {
  console.log(slide)
  let atts
  if (!isEditor) atts = ['data-scroll']
  return (
    <div style={{ minHeight: 100, padding: 100 }}>
      {slide.image && (
        <img
          width={250}
          src={slide.image.url}
          alt={slide.image.alt}
          title={slide.image.title}
          {...atts}
        />
      )}

      {slide.content || slide.caption ? (
        <div className={'slide-caption'} {...atts}>
          {slide.content && (
            <div className={'slide-caption__subtitle'}>
              {renderRichText(slide.content, 'p')}
            </div>
          )}
          {slide.caption && (
            <div className={'slide-caption__copyright'}>
              {renderRichText(slide.caption, 'p')}
            </div>
          )}
        </div>
      ) : null}
    </div>
  )
}
